import { log } from './log';

let FlushIntervalPeriod = 5000;
let logs: any[] = [];
let logUrl: string;

export function setLogUrl(url: string) {
  logUrl = url;
  if (FlushIntervalPeriod === 0) flushLogs()
}

export function setLogFlushInterval(intervalMs: number) {
  FlushIntervalPeriod = intervalMs;
  clearInterval(flushInterval);
  if (FlushIntervalPeriod !== 0) flushInterval = setInterval(flushLogs, FlushIntervalPeriod);
}

function flushLogs() {
  if (logs.length === 0 || !logUrl) return; // nothing to send or we don't yet know where to send it.

  // We would like to use the beacon api to send logs, 
  // but need to patch fluentd to return the correct CORS related headers.
  //   sendWithBeacon(); 
  // so for now, just use fetch
  sendWithFetch();
  logs = [];
}

document.addEventListener('visibilitychange', function logData() {
  if (document.visibilityState === 'hidden') {
    flushLogs();
  }
});

function queueLogEntry(logEntry: { [key: string]: any }) {
  logs.push(logEntry)
  if (FlushIntervalPeriod === 0) flushLogs();
}

let flushInterval = setInterval(flushLogs, FlushIntervalPeriod);
log.setLogOptions({
  transmit: queueLogEntry,
  enableConsole: false,
  dateTimeNow: () => new Date()
})

function sendWithFetch() {
  fetch(logUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(logs)
  });
}

function sendWithBeacon() {
  let headers = {
    type: 'application/json'
  };
  let blob = new Blob([JSON.stringify(logs)], headers);
  window.navigator.sendBeacon(logUrl, blob);
}

